module.exports = __webpack_public_path__ + "static/media/plus.f852fe6b.svg";